import DataService from "./utils/dataservice/DataService";

// Create a custom DataService instance for tasks with different base URL
class TaskDataService extends DataService {
  constructor() {
    super();
    // Override the base URL for tasks to use /api/ instead of /api/admin
    this._baseUrl = process.env.REACT_APP_API_URL?.replace('/api/admin', '/api') || 'jamborecords-devapi.scouting.org/api';
  }
}

const taskDataService = new TaskDataService();

export default class TaskService {
  static async postTaskData(data) {
    return await taskDataService.post(`task`, data);
  }
  static async getTaskList(data) {
    const queryParams = [
      data?.searchKey ? `searchKey=${data.searchKey}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.taskType ? `taskType=${data.taskType}` : "",
      data?.assigenTo ? `assigenTo=${data.assigenTo}` : "",
      data?.assigenBy ? `assigenBy=${data.assigenBy}` : "",
      data?.status ? `status=${data.status}` : "",
      data?.dueDate ? `dueDate=${data.dueDate}` : "",
      // Category values contain spaces/slashes, so they must be encoded.
      data?.taskCategory
        ? `taskCategory=${encodeURIComponent(data.taskCategory)}`
        : "",
      data?.excludeTaskCategory
        ? `excludeTaskCategory=${encodeURIComponent(data.excludeTaskCategory)}`
        : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await taskDataService.get(`task${queryString}`);
  }

  static async updateTaskData(taskId, data) {
    return await taskDataService.patch(`task/${taskId}`, data);
  }

  // Delete one or more tasks. A single delete just sends a one-element array.
  static async deleteTasks(taskIds) {
    return await taskDataService.delete(`task`, { taskIds });
  }

  static async createGroup(data) {
    return await taskDataService.post(`task/group`, data);
  }

  static async updateGroup(groupId, data) {
    return await taskDataService.patch(`group/${groupId}`, data);
  }

  static async getGroupList(data) {
    const queryParams = [
      data?.searchKey ? `searchKey=${data.searchKey}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await taskDataService.get(`task/groups${queryString}`);
  }

  static async deleteGroup(groupId) {
    return await taskDataService.delete(`task/group/${groupId}`);
  }

  static async getAssignToList(data) {
    const queryParams = [
      data?.searchKey ? `searchKey=${data.searchKey}` : "",
      data?.type ? `type=${data.type}` : "",
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await taskDataService.get(`task/assignment-options${queryString}`);
  }
}



